export default __webpack_public_path__ + "static/media/cycle20.bd76c074.jpeg";